export const parseToCurrency = (n) => {
  if (typeof n !== 'number') {
    return null;
  }

  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(n);
};
